import React, { useContext, useState } from 'react';
import clsx from 'clsx';
import {
  Button,
  CircularProgress,
  InputAdornment,
  Grid,
  TextField,
  Typography,
  FormHelperText,
} from '@material-ui/core';
import CheckIcon from '@material-ui/icons/Check';
import CancelIcon from '@material-ui/icons/Cancel';
import { PasswordConditions } from 'components';
import { Context } from 'context';
import { getCurrentYear } from 'utils';
import styles from './LoginRightPanel.module.scss';

const CreatePassword = (props) => {
  const {
    state: {
      domainConfig: { logo, logoAlt, showPoweredBy },
    },
  } = useContext(Context);

  const {
    newPassword,
    setChangeNewPassword,
    confirmPassword,
    setConfirmPassword,
    handleChangepasswordRequest,
    isChangePass,
    setshowChallengeView,
    formSubmitError,
    setFormSubmitError,
  } = props;

  const [criteriaError, setCriteriaError] = useState(true);
  const [isFormSubmitted, setFormSubmitted] = useState(false);

  const viewLogin = () => setshowChallengeView(false);

  const handleSubmit = (event) => {
    setFormSubmitted(true);
    setFormSubmitError();

    if (criteriaError || newPassword !== confirmPassword) return;

    handleChangepasswordRequest(event);
  };

  return (
    <div
      className={clsx(styles.rightContainer, {
        ['disable-form']: isChangePass,
      })}
    >
      <div className={styles.innerContainer}>
        <img className={styles.logoImage} src={logo} alt={logoAlt} />

        <Typography className={styles.headingH2} variant="h2">
          Create a new password
        </Typography>

        <Typography variant="body1">
          Enter your new account password below. Once confirmed, you'll be
          logged into your account and your new password will be active.
        </Typography>

        <div className={styles.formContainer}>
          <TextField
            fullWidth
            id="new-password"
            type="password"
            label="Enter New Password"
            variant="outlined"
            name="newPassword"
            value={newPassword}
            error={Boolean(isFormSubmitted && criteriaError)}
            helperText={
              isFormSubmitted &&
              criteriaError &&
              'Password does not meet minimum criteria'
            }
            onChange={(e) => {
              setChangeNewPassword(e.target.value);
              setFormSubmitError();
            }}
            InputProps={{
              endAdornment: newPassword && (
                <InputAdornment position="end">
                  {criteriaError ? (
                    <CancelIcon fontSize="small" className="color_error" />
                  ) : (
                    <CheckIcon fontSize="small" className="color_success" />
                  )}
                </InputAdornment>
              ),
            }}
            inputProps={{
              'data-testid': 'new-password-input',
            }}
          />

          <PasswordConditions
            password={newPassword}
            setCriteriaError={setCriteriaError}
          />

          <TextField
            fullWidth
            id="confirm-password"
            className={styles.formInputContainerWithSubBtn}
            type="password"
            label="Confirm Password"
            variant="outlined"
            name="confirmPassword"
            value={confirmPassword}
            error={Boolean(isFormSubmitted && newPassword !== confirmPassword)}
            helperText={
              isFormSubmitted &&
              newPassword !== confirmPassword &&
              "Password doesn't match confirmation"
            }
            onChange={(e) => {
              setConfirmPassword(e.target.value);
              setFormSubmitError();
            }}
            inputProps={{
              'data-testid': 'confirm-password-input',
            }}
          />

          <div
            className={clsx(
              styles.rememberContainer,
              styles.formInputContainer,
            )}
          >
            <div className={styles.rememberLinkContainer}>
              <span onClick={viewLogin} className={styles.rememberLink}>
                Login?
              </span>
            </div>
          </div>

          <div className={styles.loginBtnContainer}>
            {formSubmitError && (
              <FormHelperText className={clsx('color_error', styles.formError)}>
                <Typography variant="body1">{formSubmitError}</Typography>
              </FormHelperText>
            )}

            <Button
              variant="contained"
              color="secondary"
              fullWidth
              onClick={handleSubmit}
              data-testid="change-password-button"
              disabled={isChangePass}
            >
              {isChangePass && (
                <CircularProgress size={25} className={styles.spinner} />
              )}
              {!isChangePass && 'Submit'}
            </Button>
          </div>
        </div>

        {showPoweredBy && (
          <Grid
            container
            alignItems="center"
            justifyContent="space-between"
            className="mg_top_100"
          >
            <Grid item>
              <img src={'/images/poweredByLogo.svg'} alt={logoAlt} />
            </Grid>

            <Grid item>
              <Typography
                variant="caption"
                className={styles.rememberLinkContainer}
              >
                &copy;{getCurrentYear()} &nbsp; &#9679; &nbsp; Subscribili
                &nbsp; &#9679; &nbsp; All Rights Reserved
              </Typography>
            </Grid>
          </Grid>
        )}
      </div>
    </div>
  );
};

export default CreatePassword;
